<template>
  <div>
    <nav-bar :title="'Leaderboard'"></nav-bar>
    <ranking-skeleton v-if="loading" class="atm-desktop-max-width mobile py-4"></ranking-skeleton>
    <div v-else class="atm-desktop-max-width mobile py-4">
      <ranking-header
        :isBack="false"
        class="w-100 mx-auto mt-4"
        :points-to-next-rank="pointsToNextRank"
        :user-level="userRanking"
        :user-points="userPoints"
      ></ranking-header>
      <b-card no-body class="border-0 bg-clear" id="badge">
        <b-tabs small card>
          <b-tab
            v-for="(rank, id) in rankingAndLevelInformation"
            :key="id"
            :active="rank.level.number === userRanking.number"
            @click="getPointsToNextLevel(parseInt(id) + 1)"
          >
            <template v-slot:title>
              <div class="d-flex justify-content-center align-items-center">
                <div class="badgeContainer d-flex align-items-center bg-main p-1 mr-1 rounded-pill">
                  <img :src="rank.level.photo" alt="Badge icon" class="w-100" />
                </div>
                <label class="m-0"> Level {{ id }}</label>
              </div>
            </template>
            <ranking-table
              v-if="rank.ranking.length"
              :user-id="childId"
              :user-number="userRanking.number"
              :user-pos="userPos"
              :child-name="childName"
              :user-points="userPoints"
              :users="rank.ranking"
              :level-number="rank.level.number"
              class="atm-shadow atm-rounded overflow-hidden"
            ></ranking-table>
            <div v-else class="text-center mx-2 mt-5 no-rank">
              <b-img
                fluid
                :src="rank.level.photo"
                alt="Badge icon"
                class="content-badge mb-4"
              ></b-img>
              <p class="h5 text-muted mx-5">
                No students at
                <b>
                  {{ rank.level.name }}
                </b>
                yet.
              </p>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import rankingHeader from '../components/RankingHeader.vue';
import rankingTable from '../components/RankingTable.vue';
import rankingSkeleton from '../components/skeletons/RankingSkeleton.vue';
import { useSessionStore } from '@/common';
import { getRankingAndLevelInformation } from '../services';

export default {
  components: {
    NavBar,
    rankingHeader,
    rankingSkeleton,
    rankingTable,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      pointsToNextRank: 'none',
      userRanking: {},
      userPoints: 0,
      userPos: 0,
      rankingAndLevelInformation: {},
      loading: false,
      sessionStore,
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childName() {
      return this.sessionStore.childName;
    },
    childId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const dataRanking = await getRankingAndLevelInformation(this.childId);
      this.rankingAndLevelInformation = dataRanking.ranking
      this.userRanking = dataRanking.userLevel
      this.userPoints = dataRanking.userPoints
      this.userPos = dataRanking.userPos
      this.getPointsToNextLevel(this.userRanking.number + 1);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    getPointsToNextLevel(level) {
      const levelData = this.rankingAndLevelInformation[level]?.level;
      if (levelData){
        const pointsNeeded = levelData.points_needed - this.userPoints;
        this.pointsToNextRank =
          pointsNeeded > 0 ? pointsNeeded.toString() : 'none';
      } else{
        this.pointsToNextRank = 'none';
      }
    }
  },
}
</script>

<style lang="scss">

.no-rank .img-fluid {
  filter: invert(0.08);
}

.nav-link {
  padding: 0.5rem 0;
  text-align: center;
}

.nav-tabs .nav-item {
  font-size: 1rem;
  font-weight: 500;
  min-width: fit-content;
  padding: 10px;
  border-radius: 8px 8px 0 0;

  &:hover {
    background-color: #f2f2f2;
  }
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link {
  &:hover {
    background-color: transparent;
    border-color: transparent;
  }
}
.card-header {
  padding: 0;
  background-color: transparent;
  border: none;
}
.card-header-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: black;
  height: 100%;
  border: none;
  border-bottom: 4px solid var(--color-main) !important;
  margin: 0 !important;
}

.badgeContainer {
  width: 20px;
  height: 20px;
  box-sizing: content-box;
  & > img {
    fill: var(--color-main);
    object-fit: contain;
  }
}
</style>